import { ENDPOINTS } from "../config/endpoints";

export const teamSchema = {
  steps: [
    {
      title: "Team Details",
      fields: [
        {
          name: "name",
          type: "text",
          displayName: "Team Name",
          required: true,
        },
        {
          name: "short_name",
          type: "text",
          displayName: "Short Name",
          required: true,
        },
        {
          name: "team_type",
          type: "select",
          displayName: "Team Type",
          optionsKey: "TEAM_TYPES",
        },
        {
          name: "team_category",
          type: "select",
          displayName: "Team Category",
          optionsKey: "TEAM_CATEGORIES",
        },
        {
          name: "nationality",
          type: "select",
          displayName: "Nationality",
          fetch: ENDPOINTS.coredata.nationalities,
        },
        {
          name: "state",
          type: "select",
          displayName: "State / UT",
          optionsKey: "INDIAN_STATES",
        },
        {
          name: "city",
          type: "text",
          displayName: "City / District",
        },
        {
          name: "established_year",
          type: "text",
          inputType: "number",
          displayName: "Established Year",
        },
      ],
    },
    {
      // 2026-06-05 — rename capture. Fill these ONLY when the team is
      // being renamed (eg Royal Challengers Bangalore -> Bengaluru).
      // Backend silently ignores them when `name` hasn't changed, so
      // there's no harm in leaving them blank on a regular edit.
      title: "Renaming (optional)",
      description: "Fill these only if you're changing the team name above. Leave blank for regular edits.",
      fields: [
        {
          name: "name_change_year",
          type: "text",
          inputType: "number",
          displayName: "Year of name change",
          placeholder: "e.g. 2024",
        },
        {
          name: "name_change_reason",
          type: "textarea",
          displayName: "Reason for name change",
          placeholder: "e.g. Franchise rebrand to align with the city's official name",
        },
      ],
    },
    {
      title: "Manager / Captain Contact",
      fields: [
        { name: "contact_email",        type: "text", inputType: "email", displayName: "Contact Email" },
        { name: "contact_mobile",       type: "text", inputType: "tel",   displayName: "Contact Mobile" },
        { name: "contact_whatsapp_ok",  type: "boolean", displayName: "WhatsApp OK?" },
      ],
    },
  ],
};
